/**
 * Returns a safe in-app path for redirects. Rejects open redirects and non-path values.
 */
export function safeInternalPath(
  value: string | null | undefined,
  fallback = "/dashboard",
): string {
  if (!value || typeof value !== "string") {
    return fallback;
  }
  const t = value.trim();
  if (!t.startsWith("/") || t.startsWith("//") || t.includes("://") || t.includes("..")) {
    return fallback;
  }
  return t;
}
